import Vue from 'vue'

const state = {
  stats: [],
  graphData: {},
  graphDataAvg: {}
}

const mutations = {
  SET_DASHBOARD_STATS (state, data) {
    state.stats = data
  },
  SET_GRAPH_DATA ({ commit }, { labels, data }) {
    state.graphData = {
      labels: labels,
      data: data
    }
  },
  SET_GRAPH_DATA_AVG ({ commit }, { labels, data }) {
    state.graphDataAvg = {
      labels: labels,
      data: data
    }
  }
}

const actions = {
  getDashboardStats ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}users/GetDashboardStats`)
        .then(response => {
          commit('SET_DASHBOARD_STATS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setGraphData ({ commit }, { labels, data }) {
    commit('SET_GRAPH_DATA', { labels, data })
  },
  setGraphDataAvg ({ commit }, { labels, data }) {
    commit('SET_GRAPH_DATA_AVG', { labels, data })
  }
}

const getters = {
  getDashboardStats () {
    return state.stats
  },
  getGraphData () {
    return state.graphData
  },
  getGraphDataAvg () {
    return state.graphDataAvg
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js